/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */

export type ServiceSetupExperienceEnum =
  (typeof ServiceSetupExperienceEnum)[keyof typeof ServiceSetupExperienceEnum];

export const ServiceSetupExperienceEnum = {
  standard: 'standard',
  pet_care_modes: 'pet_care_modes',
} as const;
